export function tabLeaveHandler(callback) {
  let timer = null;

  const handleMouseLeave = (event) => {
    // Only trigger the modal if the cursor leaves the top of the window with intention to close the tab
    // Triggers when cursor out of app and not returning back to app in a 300 second
    if (event.clientY <= 0) {
      timer = setTimeout(() => {
        callback();

        document.removeEventListener('mouseleave', handleMouseLeave)
        document.removeEventListener('mouseenter', handleMouseEnter)
        timer = null;
      }, 300);
    }
  }

  const handleMouseEnter = () => {
    // Clear the timeout if the user moves the cursor back into the app
    // to prevent Feedback modal appearing
    if (timer) {
      clearTimeout(timer);
    }
  }

  document.addEventListener('mouseleave', handleMouseLeave)
  document.addEventListener('mouseenter', handleMouseEnter)
}
